import React from 'react';
import { Alert } from '../Alert/Alert';
import { StyledModal, ModalBody, ModalFooter, Title, Message } from './Styles';

interface Props {
  actions: JSX.Element | null;
  controlled?: boolean;
  errors?: string[];
  isNotificationDismissible?: boolean;
  isOpen: boolean;
  isOpenState?: boolean;
  message: string | null;
  onClose?: () => void;
  onCloseState?: () => void;
  removeErrors?: (() => void) | null;
  title?: string | null;
}

const ConfirmationModal: React.FC<Props> = ({
  actions,
  controlled,
  errors,
  isNotificationDismissible,
  isOpen: isOpenProps,
  isOpenState,
  message,
  onClose,
  onCloseState,
  removeErrors,
  title,
}) => (
  <StyledModal
    showCloseModalCross
    isOpen={controlled ? isOpenProps : isOpenState}
    onRequestClose={controlled ? onClose : onCloseState}
  >
    <ModalBody>
      {title && <Title>{title}</Title>}
      {errors && errors.length > 0 && (
        <Alert
          message={errors}
          onRequestClose={isNotificationDismissible && removeErrors ? removeErrors : undefined}
        />
      )}
      {message && <Message>{message}</Message>}
    </ModalBody>

    <ModalFooter>{actions}</ModalFooter>
  </StyledModal>
);

ConfirmationModal.defaultProps = {
  actions: null,
  controlled: true,
  isNotificationDismissible: true,
  isOpen: false,
  isOpenState: false,
  message: null,
  onClose: () => {},
  onCloseState: () => {},
  removeErrors: null,
};

export default ConfirmationModal;
